


































































































import DatePicker from "v-calendar/lib/components/date-picker.umd";
import { mapGetters } from "vuex";
import { App, General } from "@/utils/constants";
import { NUP, applyMask } from "@/utils/protocols";
import { getTimeLeft } from "@/utils/timeUtility";
import { truncate } from "lodash";
import { IProcessFilled } from "@/store/types/process-type";

export default {
  name: "CalendarAppointments",
  components: {
    DatePicker
  },
  props: {
    processList: {
      type: Array as () => IProcessFilled[],
      default: () => []
    },
    dateMarkList: {
      type: Array,
      default: () => []
    },
    attributes: {
      type: Array,
      default: null
    },
    selectAttributes: {
      type: Object,
      default: null
    },
    onSelect: {
      type: Function,
      default: () => null
    },
    load: Boolean
  },

  data() {
    return {
      App,
      General,
      date: null,
      locationConfig: {
        id: "pt-br",
        firstDayOfWeek: 1,
        masks: { weekdays: "WWW" }
      },
      isWeekdays: true,
      truncate,
      getTimeLeft
    };
  },

  computed: {
    ...mapGetters({
      isContrast: "isContrast"
    }),
    getAttributes() {
      return (
        this.attributes || [
          {
            key: "Today",
            highlight: {
              color: "green",
              fillMode: "outline",
              style: {
                border: "1px solid green",
                borderRadius: "100px"
              }
            },
            dates: new Date()
          },
          {
            key: "markDates",
            highlight: {
              style: {
                backgroundColor: "#f5dfd5",
                borderRadius: "100px"
              }
            },
            dates: this.dateMarkList
          }
        ]
      );
    },
    getSelectAttributes() {
      return (
        this.selectAttributes || {
          highlight: "green",
          content: false,
          order: 1
        }
      );
    }
  },
  watch: {
    date: {
      handler() {
        this.onSelect(this.date);
      }
    }
  },
  methods: {
    applyMaskNUP(value: string) {
      return applyMask(NUP, value);
    }
  }
};
